import { Dispatch } from 'redux'
import { clearShopDetail } from 'core/modules/shopDetail'

export function callClearShopDetail() {
  return async (dispatch: Dispatch) => {
    dispatch(clearShopDetail())
  }
}
